<template>
  <LazyAppFooterDefault v-if="route.meta.footer === 'default'" ref="footer" />
  <LazyAppFooterControl
    v-else-if="route.meta.footer === 'control'"
    ref="footer"
  />
  <LazyAppFooterApp v-else-if="route.meta.footer === 'app'" ref="footer" />
  <client-only v-if="!footer && route.meta.footer">
    <footer
      class="h-footer mx-auto shrink-0 bg-gray-100 motion-safe:animate-pulse"
    ></footer>
  </client-only>
</template>

<script setup>
const route = useRoute();

const footer = useTemplateRef("footer");
</script>
